import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import './app/common/extensions/date-extension';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
